import TestContainer from './containers/TestContainer'

// Sync route definition
export default {
  path      : '/test/:device_string',
  component : TestContainer
}



// WEBPACK FOOTER //
// ./src/routes/Test/index.js